









































import Vue from 'vue'
import Uppy from '@uppy/core'
import FileInput from "@uppy/file-input";
import XHRUpload from '@uppy/xhr-upload'

export default Vue.extend({
  name: 'SimpleFileUploader',
  props: {
    value: {
      type: Array as () => string[],
      default: () => []
    },
    companionUrl: {
      type: String,
      default: 'https://companion.uppy.io/'
    },
    autoProceed: {
      type: Boolean,
      default: false
    },
    maxFileSize: {
      type: Number,
      default: 5000000
    },
    allowedFileTypes: {
      type: Array as () => string[] | null,
      default: []
    },
    hideUploadButton: {
      type: Boolean,
      default: false
    },
    uploaderHeight: {
      type: Number,
      default: 450
    },
    inline: {
      type: Boolean,
      default: true
    },
    trigger: {
      type: String,
      default: ''
    },
    resetUploader: {
      type: Boolean,
      default: false
    },
    uploadFile: {
      type: Boolean,
      default: false
    },
    componentId: {
      type: String,
      default: ""
    },
    parentId: {
      type: Number,
      default: 0
    },
    endPoint: {
      type: String,
      default: process.env.VUE_APP_API_URL + '/Upload/UploadFile'
    },
    deleteEndPoint: {
      type: String,
      default: ''
    },
    isChecked: {
      type: Boolean ,
      default: false
    },
    uploadedFileName: {
      type: String,
      default: ""
    },
    uploadedFileLength: {
      type: Number,
      default: 0
    } ,
    uploadedFileId: {
      type: Number,
      default: 0
    },
    assetSet: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data(): {
    dialogDeleteFile: boolean;
    myUploader: any;
    urlList: string[];
    message: string;
    isInternalChecked: boolean;
    internalFileName: string;
    internalFileLength: number;
    internalFileId: number;
  } {
    return {
      dialogDeleteFile: false,
      myUploader: {},
      urlList: this.value,
      message: "",
      isInternalChecked: this.isChecked,
      internalFileName: this.uploadedFileName,
      internalFileLength: this.uploadedFileLength,
      internalFileId: 0
    }
  },
  mounted() {
    setTimeout(() => {
      this.init()
    }, 500)
  },
  watch: {
    resetUploader() {
      if (this.resetUploader) {
        this.reset()
      }
    },
    uploadFile() {
      if (this.uploadFile) {
        this.upload()
      }
    },
    isChecked() {
      this.isInternalChecked = this.isChecked
    },
    uploadedFileName() {
      this.internalFileName = this.uploadedFileName
    },
    uploadedFileLength() {
      this.internalFileLength = this.uploadedFileLength
    },
    uploadedFileId() {
      this.internalFileId = this.uploadedFileId
    }
  },
  computed :{
    fileSizeDisplay(): string {
      let someMessage = ""
      if ( this.internalFileLength ) {
        someMessage = this.bytesForHuman( this.internalFileLength );
      }

      return someMessage;
    }
  } ,
  methods: {
    init() {
      this.myUploader = new Uppy({
        id: this.componentId,
        debug: false,
        autoProceed: this.autoProceed,
        restrictions: {
          maxFileSize: this.maxFileSize,
          minNumberOfFiles: 1,
          maxNumberOfFiles: 1 ,
          allowedFileTypes: this.allowedFileTypes
        }
      })
      this.myUploader.use(FileInput, {
            id: this.componentId + "-dashboard",
            target: '#'+this.componentId ,
            locale: {
              strings: {
                chooseFiles: 'Upload File'
              }
            }
          })
          .use(XHRUpload, {
            id: this.componentId+"-xhr",
            endpoint: this.endPoint,
            metaFields: ['id', 'name', 'type', 'extension', 'size', 'componentId', 'parentId'],
            withCredentials: true
          })
          .on('file-added', (file: any) => {
            this.$emit('fileAdded', file)

            this.myUploader.setFileMeta(file.id, {
              id: file.id,
              size: file.size,
              extension: file.extension,
              componentId: this.componentId,
              parentId: this.parentId
            })
          })
          .on('file-removed', (file: any) => {
            this.$emit('fileRemoved', file)
          })
          .on('upload-success', (file: any, response: any) => {
            // this.message = "File uploaded successfully";
            console.log( "*** on upload-success in init - SimpleFileUploader")
            console.log(file);
            console.log(response)
            this.isInternalChecked = true;
            this.internalFileName = file.name;
            this.internalFileLength = file.size;
            this.internalFileId = response.body;

            console.log(this.internalFileId);


            this.$emit('uploadSuccess', file, response , this.componentId);

            this.$emit( 'uploaded' , { a: this.isInternalChecked , b: this.internalFileLength } );

          })
          .on('upload-error', (file: any, response: any) => {
            this.$emit('uploadError', file, response)
          })
          .on('complete', () => {
            this.$emit('uploadComplete')
          })
    },
    upload() {
      this.myUploader.upload()
    },
    reset() {
      this.myUploader.reset()
    },
    bytesForHuman(bytes: number, decimals = 2) : string {
      let units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB']

      let i = 0

      for (i; bytes > 1024; i++) {
        bytes /= 1024;
      }

      return parseFloat(bytes.toFixed(decimals)) + ' ' + units[i]
    },
    handleCheckboxChange( event: { toString: () => string; }) {
      // do something here
      console.log( event );
    },
    async handleDelete() {

      //let result = await this.axios.delete('/ExtensionDocuments/' + this.uploadedFileId);
      let result = await this.axios.delete(this.deleteEndPoint + this.internalFileId);

      if ( result.status === 200) {
        this.isInternalChecked = false;
        this.internalFileId = 0;
        this.internalFileLength = 0;
        this.internalFileName = "";
        //this.fileSizeDisplay = "";
        this.$emit('deleted' )
        this.dialogDeleteFile = false;
      }

      console.log(result.data);
    }
  }
})
